import { ELEVATE_LEADERSHIP_PROGRAM } from "./elevateLeadership";

export const ELEVATE_MINDSET_PATH = "/elevate-mindset";

export const ELEVATE_REFERENCES: Record<string, string> = {
  "elevate-learning-journey": "Detailed five-session learning journey",
  "elevate-opening-question": "Extended opening discussion",
  "elevate-transformation-capability": "Alignment, mindset, skillset, and toolset",
  "elevate-programming-and-learning": "Fixed rules and learned patterns",
  "elevate-capability-language": "Capability terminology and future scenarios",
  "elevate-supply-chain": "Equipment, infrastructure, and provider dependencies",
  "elevate-risk-and-opportunity": "Detailed opportunities and exposures",
  "elevate-recall-1": "Extended Session 1 recall",
  "elevate-collective-intelligence": "Individual assistance and team performance",
  "elevate-governance-brakes": "Governance as an enabling control",
  "elevate-governance-frameworks": "Frameworks, standards, and requirements",
  "elevate-recall-2": "Extended Session 2 recall",
  "elevate-ocm-purpose": "The work of adoption support",
  "elevate-adoption-patterns": "Adoption categories and different support needs",
  "elevate-case-four-levers": "Detailed four-lever briefing example",
  "elevate-net-value": "Full costs and comparable measurement",
  "elevate-change-roles": "Roles involved in organizational change",
  "elevate-change-metaphors": "Additional lenses for questioning a plan",
  "elevate-reasoning-lenses": "Additional lenses for challenging a business case",
  "elevate-recall-3": "Extended Session 3 recall",
  "elevate-championing": "The contribution of a champion",
  "elevate-kotter-mobilize": "Kotter steps 1–4 in detail",
  "elevate-kotter-sustain": "Kotter steps 5–8 in detail",
  "elevate-champion-behaviors": "Credibility through service and accountability",
  "elevate-recall-4": "Extended Session 4 recall and discussion",
  "elevate-stakeholder-map": "Detailed stakeholder relationship example",
  "elevate-situational-awareness": "Known and unknown information framework",
  "elevate-risk-classification": "Detailed use-case risk comparison",
  "elevate-shadow-ai": "Discovering and registering tools and agents",
  "elevate-standards-in-practice": "Standards detail for follow-up",
  "elevate-missing-link": "Change-plan diagnostic framework",
  "elevate-portfolio-decisions": "Portfolio-level extension",
  "elevate-capability-benchmarks": "Benchmark interpretation reference",
  "elevate-human-skills": "Human capability reference",
  "elevate-personal-roadmap": "Four development stages",
  "elevate-further-concepts": "Additional terminology",
  "elevate-resources-change": "Further reading",
};

export const ELEVATE_CORE_SLIDE_IDS = ELEVATE_LEADERSHIP_PROGRAM.slides
  .filter(slide => !ELEVATE_REFERENCES[slide.id]).map(slide => slide.id);

const aliases: Record<string, string> = {
  "elevate-adoption-and-acceptance": "TAM technology acceptance model usefulness ease intention",
  "elevate-johari-window": "Johari feedback blind spots self awareness",
  "elevate-pilot-charter": "charter pilot scope purpose governance",
  "elevate-decision-rights": "may do must ask must not do action boundaries",
};
export const matchesElevateTopic = (slide: typeof ELEVATE_LEADERSHIP_PROGRAM.slides[number], query: string): boolean => {
  const text = `${slide.title} ${slide.id} ${slide.lead ?? ""} ${aliases[slide.id] ?? ""} ${slide.sections?.map(row => `${row.title} ${row.body}`).join(" ") ?? ""}`.toLocaleLowerCase();
  return query.trim().toLocaleLowerCase().split(/\s+/).every(word => text.includes(word));
};
